// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"1253bec0","778":"d871848d"}[chunkId] + ".chunk.css";
};